import {fromJS, Map} from 'immutable';

import {
  REQUEST_PASSWORD_RESET_FULFILLED,
  REQUEST_PASSWORD_RESET_PENDING,
  REQUEST_PASSWORD_RESET_REJECTED,
  RESET_REQUEST_PASSWORD_RESET_FORM,
  SET_REQUEST_PASSWORD_RESET_FORM,
} from '../../actions';

const initialState = new Map({
  submitting: false,
  model: new Map({
    email: '',
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_PASSWORD_RESET_PENDING:
      return state.set('submitting', true);

    case REQUEST_PASSWORD_RESET_FULFILLED:
      return state.set('submitting', false);

    case REQUEST_PASSWORD_RESET_REJECTED:
      return state.set('submitting', false);

    case RESET_REQUEST_PASSWORD_RESET_FORM:
      return initialState;

    case SET_REQUEST_PASSWORD_RESET_FORM:
      return state.setIn(['model', action.payload.name], action.payload.value);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/passwordManagement/reducers/pages/requestPasswordReset.js